var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "characters-page" },
    [
      _c("sp-tab", {
        attrs: { active: "characters", hidden: !!_vm.characterId },
      }),
      _vm.characters
        ? _c(
            "list-template",
            {
              attrs: {
                active: !!_vm.characterId,
                selected: _vm.selectedCharacter,
              },
            },
            [
              _vm.characterFolders && _vm.isShowFolderList
                ? _c(
                    "div",
                    { attrs: { slot: "side" }, slot: "side" },
                    [
                      _c("character-folder-list", {
                        attrs: {
                          novelId: _vm.novelId,
                          items: _vm.characterFolders,
                          charactersCount: _vm.charactersCount,
                          isInsert: _vm.isFolderInsertMode,
                          selectedCharacter: _vm.targetCharacter,
                        },
                        on: {
                          selectedFolder: _vm.selectFolder,
                          clickCompleteSetFolder: function ($event) {
                            return _vm.finishFolderSelect()
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { attrs: { slot: "side" }, slot: "side" },
                    [
                      _c("character-list", {
                        attrs: {
                          slot: "side",
                          novelId: _vm.novelId,
                          characters: _vm.characters,
                          selectedId:
                            _vm.selectedCharacter &&
                            _vm.selectedCharacter.characterId,
                          folder: _vm.characterFolder,
                          allFolders: _vm.characterFolders,
                        },
                        on: {
                          backToFolderList: function ($event) {
                            return _vm.showFolderList()
                          },
                          clickSetFolder: _vm.setFolder,
                        },
                        slot: "side",
                      }),
                    ],
                    1
                  ),
              _c(
                "back-to-list",
                {
                  attrs: {
                    slot: "back-to-list",
                    to: {
                      name: "characters",
                      params: { novelId: _vm.novelId },
                    },
                  },
                  slot: "back-to-list",
                },
                [_vm._v(_vm._s(_vm.$t("characterPage.backToList")))]
              ),
              _vm.selectedCharacter
                ? _c("character-detail", {
                    attrs: {
                      slot: "main",
                      novelId: _vm.novelId,
                      character: _vm.selectedCharacter,
                      "editor-menu-visible": true,
                    },
                    on: {
                      showHistoryDialog: function ($event) {
                        _vm.isHistoryManageDialogOpen = true
                      },
                    },
                    slot: "main",
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.selectedCharacter
        ? _c("history-manage-dialog", {
            attrs: {
              "is-open": _vm.isHistoryManageDialogOpen,
              "data-type": "ch",
              title:
                _vm.$t("historyManageDialog.title.characterDetail") +
                " - " +
                (_vm.selectedCharacter.name || "No Name"),
              "novel-id": _vm.novelId,
              "data-id": _vm.selectedCharacter.characterId,
            },
            on: {
              close: function ($event) {
                _vm.isHistoryManageDialogOpen = false
              },
              restore: _vm.onCharacterRestore,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "notification",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "historyManageDialog.notification.localImageExcluded"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function ({ historyItem }) {
                    return [
                      historyItem
                        ? _c("character-detail", {
                            attrs: {
                              "novel-id": _vm.novelId,
                              character: {
                                ...historyItem.item,
                                characterId: _vm.selectedCharacter.characterId,
                              },
                              "editor-menu-visible": false,
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              2345657193
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }